import { render, staticRenderFns } from "./ExpansionPanelHeader.vue?vue&type=template&id=327cac5b&"
import script from "./ExpansionPanelHeader.js?vue&type=script&lang=js&"
export * from "./ExpansionPanelHeader.js?vue&type=script&lang=js&"
import style0 from "./ExpansionPanelHeader.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VExpansionPanelHeader,VIcon})
